import React from 'react';
import { withCookies, Cookies } from 'react-cookie';
import PropTypes from 'prop-types';
import { OnVisible } from '@americanexpress/data-manager-utils';
import { compose } from 'redux';
import clsx from 'clsx';
import { useMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { Modal, ModalHeader } from '@americanexpress/dls-react';
import { HOTEL_CREDIT_MODAL_COOKIE } from '../../constants/cookiesConstants';
import { isModalDismissed, setModalCookies } from '../../utils/cookiesUtils';
import ModalContent from './ModalContent';
import styles from './HotelCreditModal.scss';
import { FETCHER_OPTS, MEMBERSHIP_QUERY } from '../../constants/membershipDomainConstants';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const HotelCreditModal = ({ cookies, isWaitingForMr }) => {
  const [showModal, setShowModal] = React.useState(false);
  const { data } = useMembershipDomainFetchye({ query: MEMBERSHIP_QUERY }, {}, FETCHER_OPTS);
  const awardName = useDataFromOneCMS('hotelCreditModal.awardName');

  const accounts = data?.data?.membership || [];
  const defaultCard = accounts.find((account) => account.demographics?.isTopCard) || accounts[0];
  const isMultiCard = accounts.length > 1;
  const accountToken = defaultCard?.accountToken;
  const travelCredits = defaultCard?.travelCredits || [];

  const isHotelCreditEligible = !!awardName && !!travelCredits
    .find((credit) => credit.awardName === awardName);
  const isHotelCreditModalDismissed = isModalDismissed(
    cookies.get(HOTEL_CREDIT_MODAL_COOKIE),
    accountToken
  );

  React.useEffect(() => {
    const hasMrModalBeenDismissed = isMultiCard ? !isWaitingForMr : true;
    if (
      isHotelCreditEligible
      && !isHotelCreditModalDismissed
      && hasMrModalBeenDismissed
    ) {
      setShowModal(true);
    }
  }, [
    isHotelCreditEligible,
    isHotelCreditModalDismissed,
    isMultiCard,
    isWaitingForMr,
  ]);

  const dismissModal = () => {
    setModalCookies(cookies, accountToken);
    setShowModal(false);
  };

  if (!showModal) {
    return null;
  }

  return (
    <OnVisible
      analyticsInfo={{
        element: 'tls-credit-overlay-platinum',
        detail: 'axp-travel-credit',
      }}
    >
      <Modal
        className={clsx(
          'flex flex-column flex-align-items-center',
          styles.modalWrapper
        )}
        aria-labelledby="hotelCreditModalHeader"
        aria-describedby="hotelCreditModalBody"
        id="hotelCreditModal"
        onClose={dismissModal}
      >
        <ModalHeader
          id="hotelCreditModalHeader"
          className="flex flex-justify-between"
          closeButtonProps={{ reactlytics: { element: 'dismissModal' } }}
          hideCloseButton={false}
        >
          <h2 className="fluid heading-3 pad-2-l" id="hotelCreditModalHeader">
            Hotel Credit
          </h2>
        </ModalHeader>
        <ModalContent onCallToActionClick={dismissModal} />
      </Modal>
    </OnVisible>
  );
};

HotelCreditModal.propTypes = {
  isWaitingForMr: PropTypes.bool.isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
};

export { HotelCreditModal as TestableHotelCreditModal };

const hocChain = compose(withCookies);
export default hocChain(HotelCreditModal);
